import React from 'react';

export function LoadingPage() {
  return <div className="page-loading" role="status">Caricamento…</div>;
}
